import { render } from "./ThroughBlocksView.vue?vue&type=template&id=9bbf0956"
import script from "./ThroughBlocksView.vue?vue&type=script&lang=js"
export * from "./ThroughBlocksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__